import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PAGE_MAP } from '../../../environments/environment';
import { APP_ENVIRONMENT } from '../../app-environment.token';
import { CMS_TOKEN } from '../../common/cms/cms-token.interceptor';
import { AbstractFetchAdaptor } from '../../common/fetch/abstract-fetch.adaptor';

export interface CMSPageProps {
  name: keyof typeof PAGE_MAP;
}

export interface CMSPageResponse {}

@Injectable()
export class CMSPageFetchAdaptor extends AbstractFetchAdaptor<CMSPageProps, CMSPageResponse> {
  name = 'cms-page';

  private appEnv = inject(APP_ENVIRONMENT);
  private http = inject(HttpClient);

  // Use backend proxy endpoint to download referral form from S3
  referralFormLink = `${this.appEnv.apiURL}/accounts/download_referral_form`;

  onRequest(props: CMSPageProps): Observable<CMSPageResponse> {
    return this.http.get(this.appEnv.cmsApiURL + `/pages/${PAGE_MAP[props.name]}`, {
      context: new HttpContext().set(CMS_TOKEN, this.appEnv.cmsToken),
    });
  }
}
